import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_NOTIFICATION_TEMPLATE_LIST, MANAGE_NOTIFICATION_TEMPLATE_ADD, MANAGE_NOTIFICATION_TEMPLATE_VIEW, MANAGE_NOTIFICATION_TEMPLATE_EDIT, MANAGE_NOTIFICATION_TEMPLATE_DELETE, MANAGE_NOTIFICATION_HTML_TEMPLATE } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const notificationApi = createApi({

    reducerPath: 'notificationApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/notification-template",
    }),
    tagTypes: ["TemplateList", "TemplateDetails"],
    endpoints: (builder) => ({

        // get template list
        getTemplateList: builder.query({
            query: ({ type = "email", search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "desc" } }) => ({
                method: "PATCH",
                url: MANAGE_NOTIFICATION_TEMPLATE_LIST,
                data: { type, search, status, page, limit, sort, },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TemplateList"]
        }),

        // get template data
        getTemplateDetail: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_NOTIFICATION_TEMPLATE_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TemplateDetails"]
        }),

        // create template
        createTemplate: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_NOTIFICATION_TEMPLATE_ADD,
                data
            }),
            invalidatesTags: ["TemplateList"]
        }),

        // update template
        updateTemplate: builder.mutation({
            query: ({ data, templateId }) => ({
                method: "PUT",
                url: `${MANAGE_NOTIFICATION_TEMPLATE_EDIT}/${templateId}`,
                data
            }),
            invalidatesTags: ["TemplateList", "TemplateDetails"]
        }),

        // delete template
        deleteTemplate: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_NOTIFICATION_TEMPLATE_DELETE}/${id}`
            }),
            invalidatesTags: ["TemplateList", "TemplateDetails"]
        }),

        // get html template data
        getHtmlTemplate: builder.query({
            query: (name) => ({
                method: "GET",
                url: `${MANAGE_NOTIFICATION_HTML_TEMPLATE}/${name}`
            }),
            transformResponse: (response) => {
                return response.data;
            }
        })
    }),
})

export const {

    useGetTemplateListQuery,
    useCreateTemplateMutation,
    useUpdateTemplateMutation,
    useGetTemplateDetailQuery,
    useDeleteTemplateMutation,
    useLazyGetHtmlTemplateQuery

} = notificationApi;